'use client';
import {
  FaArrowLeft,
  FaFacebookF,
  FaInstagram,
  FaXmark,
  FaYoutube,
} from 'react-icons/fa6';
import HeaderClient from './HeaderClient';
import Link from 'next/link';
import HeaderCart from './HeaderCart';
import MobileMenuItem from './MobileMenuItem';
import SearchComponent from './SearchComponent';
import BrowseCategories from '@/features/header/BrowseCategories';
import { useFetcherCSR } from '@/lib/useFetcherCSR';
import Image from 'next/image';
import SidebarAction from './SidebarAction';
import { useEffect, useState } from 'react';
import DiscountHeader from './DiscountHeader';

const menuData = [
  { title: 'Shop', href: '/shop' },
  { title: 'Blogs', href: '/blogs' },
  { title: 'Contact Us', href: '/contact' },
  { title: 'FAQ', href: '/faq' },
  { title: 'Kirei Community', href: '/community' },
  { title: 'About Us', href: '/about-us' },
  { title: 'Kirei Tube', href: '/kirei-tube' },
  { title: 'Return & Refund', href: '/return-refund' },
  { title: 'Terms & Condition', href: '/term-condition' },
  { title: 'Testimonials', href: '/testimonials' },
  { title: 'Responsible Disclosure', href: '/responsible-disclosure' },
];

const socialKeys = [
  'facebook_link',
  'instagram_link',
  'youtube_link',
  'hot_deals_start_datetime',
  'hot_deals_end_datetime',
];

const Header = () => {
  const { data: sidebarData } = useFetcherCSR(`/api/v2/sidebar-data?new=true`);
  const { data } = useFetcherCSR(`/api/v2/general-settings`);

  const topBarMessage = data?.data?.filter(
    (item: any) => item?.type === 'topbar_message'
  );
  const socialData = data?.data?.reduce((acc: any, item: any) => {
    if (socialKeys.includes(item.type) && item.value) {
      acc[item.type] = item.value;
    }
    return acc;
  }, {});

  const todaysDate = new Date();
  const startDate = new Date(socialData?.hot_deals_start_datetime);
  const endDate = new Date(socialData?.hot_deals_end_datetime);
  const isHotDealActive = todaysDate >= startDate && todaysDate <= endDate;

  console.log(isHotDealActive);

  const [isSticky, setIsSticky] = useState(false);
  const [isStickyTopMessage, setIsStickyTopMessage] = useState(true);

  useEffect(() => {
    let lastScrollTop = 0;
    const header = document.querySelector('.header') as HTMLElement;

    function onScroll() {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > 100) {
        setIsStickyTopMessage(false);
        if (scrollTop < lastScrollTop) {
          // Scrolling up
          header?.classList.add('sticky');
          setIsSticky(true);
        } else {
          // Scrolling down
          header?.classList.remove('sticky');
          setIsSticky(false);
        }
      } else {
        // Less than 100px from top, remove sticky
        header?.classList.remove('sticky');
        setIsSticky(false);
        setIsStickyTopMessage(true);
      }

      lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    }

    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <HeaderClient>
      <header className={`header `}>
        <div className="header__wrapper">
          {/* Header Top Starts */}
          {topBarMessage?.[0]?.value && isStickyTopMessage && (
            <DiscountHeader data={topBarMessage?.[0]?.value} />
          )}

          <div className="header-top d-none d-xl-block">
            <div className="container">
              <div className="header-top__wrapper">
                <div className="header__brand">
                  <Link href="/">
                    <Image
                      width={110}
                      height={77}
                      src="/images/logo/logo.svg"
                      alt="logo"
                    />
                  </Link>
                </div>
                {/* Search component for large device */}
                <SearchComponent />
                <div className="header__contact">
                  <div className="header__contact-thumb">
                    <Image
                      height={41}
                      width={41}
                      src="/images/social/whatsapp.png"
                      alt="support-icon"
                    />
                  </div>
                  <div className="header__contact-number">
                    <span>Support </span>
                    <h6 className="mb-0 fw-medium">
                      <Link
                        href="https://wa.me/8801779991110"
                        className="stretched-link"
                        target="_blank"
                        rel="noopener noreferrer"
                      />{' '}
                      +880 177 999 1110
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Header Top ends */}

          {/* Header Bottom Starts */}
          <div
            className={`header-bottom ${isSticky ? 'd-block position-sticky' : ''}`}
          >
            <div className="container">
              <div className="header-bottom__wrapper">
                <div className="header__brand d-xl-none">
                  <div className="d-flex align-items-center gap-3">
                    <button type="button" className="menu-mobile-trigger">
                      <span />
                      <span />
                      <span />
                      <span />
                    </button>
                    <div>
                      <Link href="/">
                        <img src="/images/logo/logo.svg" alt="logo" />
                      </Link>
                    </div>
                  </div>
                </div>

                <BrowseCategories />

                {/* Section: Navbar Menu */}
                <div className="header__navbar">
                  <div className="header__overlay" />

                  <nav className="menu menu-mobile">
                    <div className="menu-mobile-header">
                      <button
                        type="button"
                        id="menu-mobile-arrow"
                        className="menu-mobile-arrow"
                      >
                        <FaArrowLeft />
                      </button>
                      <div className="menu-mobile-title">
                        <Link href="/">
                          <img src="/images/logo/logo.svg" alt="logo" />
                        </Link>
                      </div>
                      <button type="button" className="menu-mobile-close">
                        <FaXmark />
                      </button>
                    </div>

                    {/* Desktop sidebar items */}
                    <ul className="menu-section desktop-menu-section">
                      <li className="menu-item-has-children">
                        <Link href="/">Home</Link>
                      </li>
                      {isHotDealActive && (
                        <li>
                          <Link href="/hot-deals">Hot Deals</Link>
                        </li>
                      )}

                      <li className="menu-item-has-children">
                        <Link href="/shop">Shop</Link>
                      </li>
                      <li className="menu-item-has-children">
                        <Link href={'/blogs'}>Blogs</Link>
                      </li>
                      <li>
                        <Link href="/contact">Contact</Link>
                      </li>
                    </ul>

                    {/* Mobile sidebar items */}

                    <div className="header__support d-xl-none my-4 px-4">
                      <div className="d-flex align-items-center justify-content-center gap-3 py-1 px-3 position-relative border rounded-3">
                        <div className="header__support-thumb">
                          <Image
                            src="/images/social/whatsapp.png"
                            alt="support-icon"
                            height={41}
                            width={41}
                          />
                        </div>
                        <div className="header__support-number">
                          <span>Support</span>
                          <h4 className="mb-0 fw-semibold">
                            <Link
                              href="https://wa.me/8801779991110"
                              className="stretched-link"
                              target="_blank"
                              rel="noopener noreferrer"
                            />{' '}
                            +880 177 999 1110
                          </h4>
                        </div>
                      </div>
                    </div>

                    <ul className="menu-section mobile-menu-section d-xl-none">
                      {[{ title: 'Home', href: '/' }].map((item, index) => (
                        <MobileMenuItem item={item} key={index} />
                      ))}
                      {sidebarData?.sidebarList?.map(
                        (item: any, index: number) => (
                          <MobileMenuItem item={item} key={index} />
                        )
                      )}
                      {menuData.map((item, index) => (
                        <MobileMenuItem item={item} key={index} />
                      ))}
                    </ul>

                    <SidebarAction />

                    <div className="sidebar-social pt-4 pb-5 d-flex justify-content-center d-xl-none">
                      <ul className="social">
                        <li className="social__item">
                          <a
                            href={socialData?.facebook_link}
                            target="_blank"
                            className="social__link"
                          >
                            <FaFacebookF />
                          </a>
                        </li>
                        <li className="social__item">
                          <a
                            href={socialData?.youtube_link}
                            target="_blank"
                            className="social__link"
                          >
                            <FaYoutube />
                          </a>
                        </li>
                        <li className="social__item">
                          <a
                            href={socialData?.instagram_link}
                            target="_blank"
                            className="social__link"
                          >
                            <FaInstagram />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </nav>
                </div>

                <div className="header__action">
                  <HeaderCart />

                  <div className="trk-search__overlay" />
                </div>
              </div>
              <div className="d-xl-none mt-3">
                {/* <SearchMobileComponent /> */}
                <SearchComponent />
              </div>
            </div>
          </div>
          {/* Header Bottom ends */}
        </div>
      </header>
    </HeaderClient>
  );
};

export default Header;
